export const displaySgzSpecificDetailPanelSelector = ({displaySgzSpecificDetailPanel}) => displaySgzSpecificDetailPanel
